import { render, staticRenderFns } from "./bidpredict.vue?vue&type=template&id=2d9cf2c8"
import script from "./bidpredict.vue?vue&type=script&lang=js"
export * from "./bidpredict.vue?vue&type=script&lang=js"
import style0 from "./bidpredict.vue?vue&type=style&index=0&id=2d9cf2c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports